export default {
  'achTotals.header': 'File Totals Notifications',

  'achTotals.contactPerson': 'Contact Person',
  'achTotals.contactPhone': 'Contact Phone',
  'achTotals.customerName': 'Customer Name',
  'achTotals.creditAmount': 'Total Credit Amount',
  'achTotals.debitAmount': 'Total Debit Amount',
  'achTotals.sentOn': 'Sent On',
  'achTotals.sentBy': 'Sent By',
  'achTotals.successNotificationTitle': 'Total Request Has Been Submitted',
  'achTotals.successNotification':
    'A confirmation email has been sent to <%= email %>. Please print this confirmation for your records.',
  'achTotals.successNotificationAdditional':
    'An ACH Totals request has been submitted with the information described above. Please press the print button on your browser to generate a hard copy of this confirmation. This transaction is subject to bank rules and regulations governing such electronic transactions as described in our services agreement. Please keep these numbers handy in case you have any questions regarding this request. If any portion of the above is incorrect, or you have further questions, please contact customer service.'
};
